export default __webpack_public_path__ + "static/media/doc3.92b7675b.jpg";